class UtilFunctions {

	/**
	 * Prevent numeric symbols like e, + and -
	 *
	 * @param event
	 */
	static preventNumericSymbols( event ){

		if (event.key === "e" || event.key === "+" || event.key === "-") {
			event.preventDefault();
		}

	}

	/**
	 * Check if Age is accepted
	 *
	 * @param birth_date
	 * @param accepted_age
	 * @returns {boolean}
	 */
	static checkAcceptedAge(birth_date, accepted_age) {

		let date = this.getDate(birth_date, 'dd/MM/YY');

		return this.getAge(date) > accepted_age;
	}

	/**
	 * Get the Age
	 *
	 * @param birth_date
	 * @returns {number}
	 */
	static getAge(birth_date) {
		birth_date = new Date(birth_date);

		let month_diff = Date.now() - birth_date.getTime();

		let age_dt = new Date(month_diff);

		let year = age_dt.getUTCFullYear();

		return Math.abs(year - 1970);
	}

	/**
	 * Get date in format
	 *
	 * @param date
	 * @param format
	 * @returns {string}
	 */
	static getDate(date, format){
		let theDate = '';

		if (format === "dd/MM/YY"){
			if (date) {

				let v = date.toString();

				let yy = parseInt(v.split('-')[0]) ;
				let mm = parseInt(v.split('-')[1]) - 1;
				let dd = parseInt(v.split('-')[2]);

				theDate = new Date(new Date(yy, mm, dd));

			}
		}

		return theDate;
	}

}

export default UtilFunctions;
